export const sidebar_data = [
  {
    logo: "./assets/img/contact-icon.png",
    name: "Contacts",
    link: "/Contacts",
  },
  {
    logo: "./assets/img/deal-icon.png",
    name: "Deals",
    link: "/",
  },
  {
    logo: "./assets/img/application-icon.png",
    name: "Applications",
    link: "/",
  },
  {
    logo: "./assets/img/event-icon.png",
    name: "Events",
    link: "/",
  },
  {
    logo: "./assets/img/Deals.svg",
    name: "Courses",
    link: "/",
  },
  {
    logo: "./assets/img/task-icon.png",
    name: "Task",
    link: "/",
  },
  {
    logo: "./assets/img/repository-icon.png",
    name: "Repository",
    link: "/",
  },
  {
    logo: "./assets/img/marketing-icon.png",
    name: "Marketing",
    link: "/",
  },
  {
    logo: "./assets/img/sales-icon.png",
    name: "Sales",
    link: "/",
  },
  {
    logo: "./assets/img/workflow-icon.png",
    name: "Workflow",
    link: "/",
  },
  {
    logo: "./assets/img/Report-icon.png",
    name: "Report",
    link: "/",
  },
];
